import z from "zod";
import { MetaSchema } from "./shared";

export const AuthIdentityWalletNonceDataSchema = z.object({
  nonce: z.string(),
  message: z.string(),
});

const AuthIdentityWalletNonceResponseSchema = z.object({
  data: AuthIdentityWalletNonceDataSchema,
  meta: MetaSchema.default,
});

export default AuthIdentityWalletNonceResponseSchema